import * as React from "react";
import { FunctionComponent, useEffect, useState } from "react";
import { useForm } from "react-hook-form/dist/index.ie11";
import axios from "axios";
import { HideSpinner, ShowSpinner } from "../../../ts/components/spinner";
import * as UserCentrics from "../../../ts/shared/user-centrics";
import { initCloudflare } from "../../../ts/shared/user-centrics";

interface IProps {
	SiteKey: string;
}

declare global {
	interface Window {
		turnstile: any;
	}
}

export const PasswordVergessenForm: FunctionComponent<IProps> = (props: IProps) => {
	const { register, handleSubmit, errors, reset } = useForm({
		defaultValues: {
			username: ""
		}
	});

	const [passswordResetError, setPassswordResetError] = useState(false);
	const [passwordResetSuccess, setPasswordSuccessReset] = useState(false);
	const [showCaptchaError, setShowCaptchaError] = useState(false);

	useEffect(() => {
		initCloudflare();
	}, [props.SiteKey]);

	function postData(password: Record<string, any>) {
		axios
			.post(`/umbraco/api/PasswordReset/passwordVergessenEmailSubmit`, password)
			.then(() => {
				HideSpinner();
				setPasswordSuccessReset(true);
				reset({});
			})
			.catch((error: any) => {
				HideSpinner();
				if (error?.response?.data?.Message) {
					setPassswordResetError(true);
				}
			});
	}

	function onSubmit(password: Record<string, any>) {
		if (!UserCentrics.IsCloudflareAllowed()) {
			return;
		}

		ShowSpinner();

		if (!window.turnstile && !window.turnstile.getResponse()) {
			setShowCaptchaError(true);
			HideSpinner();
			return;
		}

		password.token = window.turnstile.getResponse();
		postData(password);
	}

	return (
		<React.Fragment>
			<form onSubmit={handleSubmit(onSubmit)}>
				{passwordResetSuccess && (
					<div className="form-success">
						E-Mail mit Link zum Zurücksetzen Ihres Passwortes wurde erfolgreich versandt!
					</div>
				)}
				<div className="row sign-up__form">
					<div className="col-lg-12 col-sm-12">
						<div className="form-group row">
							<label htmlFor="Username" className="col-sm-6  col-lg-6 col-form-label">
								E-Mail:<span className="mandatory">*</span>
							</label>
							<div className="col-sm-6">
								<input
									type="input"
									className="form-control"
									id="Username"
									name="Username"
									placeholder="E-Mail/Benutzername"
									maxLength={60}
									ref={register({
										required: true,
										max: 60
									})}
								/>
								{errors.username && <div className="form-error">Bitte geben Sie Ihre E-Mail/Benutzername ein.</div>}
							</div>
						</div>
					</div>
				</div>

				<div className="row sign-up__form " style={{ display: "none" }}>
					<div className="col-lg-12 col-sm-12">
						<div className="form-group row">
							<label htmlFor="Mail" className="col-sm-6  col-lg-6 col-form-label">
								E-Mail:<span className="mandatory">*</span>
							</label>
							<div className="col-sm-6">
								<input
									type="input"
									className="form-control"
									id="Mail"
									name="Mail"
									placeholder="E-Mail/Benutzername"
									maxLength={60}
									ref={register({
										required: false,
										max: 60
									})}
								/>
							</div>
						</div>
					</div>
				</div>

				{/* Cloudflare Turnstile widget */}
				<div className="form-group row">
					<div className="col-sm-6"></div>
					<div className="col-sm-6 form">
						<div className="cf-turnstile-uc" data-sitekey={props.SiteKey}></div>
						{showCaptchaError && (
							<span id="password_input_error" className="form-error">
								Bitte füllen Sie das Captcha aus, um fortzufahren.
							</span>
						)}
					</div>
				</div>
				<div className="row">
					<div className="col-12 col-sm-6"></div>
					<div className="col-12 col-sm-6 text-right">
						<button className="button button__cta button--red order__button">
							<span className="txt">Abschicken</span>
							<i className="fas fa-arrow-right icon-fa icon--white"></i>
						</button>
						{passswordResetError && <div className="form-error">{passswordResetError}</div>}
					</div>
				</div>
			</form>
		</React.Fragment>
	);
};
